jQuery.noConflict();
(function( $ ) {
    $(function() {
    //Document Ready STARTS

        var wdata = [];
        wdata.mobileWidth = 640;
        wdata.swiper = [];
        wdata.debug = false;

        //PLACEHOLDERS
        $('input, textarea').placeholder(); //add placeholders for load browsers

        function afterLoad() {
            svgSupport();
            updateWData();
            runSwiper();
            lazyBg();
            layoutBlockVis();
            removeSplash();
            bindClick();
            $('.mobile-nav').attr('style', '');
        }

        afterLoad();

        // Functions On Window resize
        $(window).on('resize', function(){
            updateWData();
            lazyBg();
            layoutBlockVis();
        });

        // Window scroll
         $(window).on('scroll', function(){
            wdata.scrollTop = $(window).scrollTop();
            lazyBg();
            layoutBlockVis();
        });

        // mobile menu toggle functions
        $('.hamburger').on('click', function(e){
            e.preventDefault();
            $(this).toggleClass('is-active');
            $('.mobile-nav').toggleClass('active');
            $('body').toggleClass('scroll-lock').toggleClass('mobile-menu');
        });

        $('.close-menu').on('click', function(e){
            $('.hamburger').trigger('click');
        });

        //Adjust Header spacer height
        function spacerHeight() {
            $('.header-spacer').attr('style', '');
            var headerHeight = $('.header').outerHeight();
            $('.header-spacer').height(headerHeight);
        }

        //Check if DOM has MAP
        if(($('#map').data('lat') != '') && ($('#map').data('lat') != undefined)) {
            initMap();
        }

        function removeSplash() {
            $( '.splishs-plash-splosh').fadeTo( 'fast' , 0.1, function() {
                $( '.splishs-plash-splosh').remove();
            });
        }

        function isNumber(value) {
            return typeof value === 'number';
        }

        /* Run sliders */
        function runSwiper() {
            var centerSlides = false;
            var starSlide = 0;
            if (wdata.ww < wdata.mobileWidth) {
                centerSlides = true;
                starSlide = 1;
            }

            $.each($('.sw-wrap .swiper-container'), function(e){
                var sliderId = $(this).attr('id'),
                    rowId = $(this).attr('data-id');
                if (sliderId != undefined && sliderId != '') {

                    var options = {
                        slidesPerView: 'auto',
                        speed: 600,
                        autoHeight: true,
                        centeredSlides: centerSlides,
                        initialSlide: starSlide,
                        spaceBetween: 0,
                        navigation: {
                            nextEl: '.next-'+rowId,
                            prevEl: '.prev-'+rowId,
                        },
                        keyboard: {
                            enabled: true,
                            onlyInViewport: true,
                        },
                    };

                    if ($('#'+sliderId).attr('data-autoplay') != undefined && $('#'+sliderId).attr('data-autoplay') != '') {
                        var delay = $('#'+sliderId).attr('data-autoplay');
                        if (isNumber(delay)) {
                            options.autoplay = {
                                delay: delay,
                                disableOnInteraction: false,
                            };
                        }
                        else {
                            options.autoplay = {
                                delay: 5000,
                                disableOnInteraction: false,
                            };
                        }
                    }

                    console.log(options);

                    wdata.swiper[sliderId] = new Swiper('#'+sliderId, options);
                }
            });

            if ($('.logos-slider').length>0) {
                var logosSlider = new Swiper('.logos-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    speed: 800,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    loop: true,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        clickable: true,
                    },
                });
            }

            if ($('.images-slider').length>0) {
                var imagesSlider = new Swiper('.images-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    speed: 800,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    loop: true,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        clickable: true,
                    },
                });
            }

            if ($('.product-gallery').length>0) {
                var swiperThumbs = new Swiper(".gallery-thumbs", {
                    loop: true,
                    spaceBetween: 15,
                    slidesPerView: 4,
                    freeMode: true,
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: '.th-next',
                        prevEl: '.th-prev',
                    },
                });

                var gallerySlider = new Swiper('.product-gallery', {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    speed: 800,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    loop: true,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        clickable: true,
                    },
                    thumbs: {
                        swiper: swiperThumbs,
                    },
                });
            }
        }

        //init MAP with custom settings
        function initMap() {

            var $mapDiv = $('#map'),
                lat = $mapDiv.data('lat'),
                lan = $mapDiv.data('lan'),
                zoom = $mapDiv.data('zoom'),
                markerImg = $mapDiv.data('marker'),
                title = $mapDiv.data('title'),
                windowHeight = $( window ).height(),
                mapHeight =  (windowHeight/2) - 150;

            //set map height to half window height
            if (mapHeight<400) {
                mapHeight = 400;
            }

            $mapDiv.height(mapHeight);

            var optionNavigationControl = false,
                optionTypeControl = true,
                optionScaleControl = true,
                optionDraggable = true,
                optionScrollwheel = false;
            if($('body').hasClass('mobile')) {
                    optionNavigationControl = false;
                    optionTypeControl = false;
                    optionScaleControl = false;
                    optionDraggable = false;
                    optionScrollwheel = false;
            }

            var myLatLng = {lat: lat, lng: lan};
            var map = new google.maps.Map(document.getElementById('map'), {
                zoom: zoom,
                // mapTypeId: google.maps.MapTypeId.SATELLITE,
                navigationControl: optionNavigationControl,
                mapTypeControl: optionTypeControl,
                scaleControl: optionScaleControl,
                draggable: optionDraggable,
                scrollwheel: optionScrollwheel,
                center: myLatLng
            });

            var markerImage = new google.maps.MarkerImage(markerImg,
                new google.maps.Size(41, 61), //size
                new google.maps.Point(0, 0), //origin point
                new google.maps.Point(20, 61)); // offset point

            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: markerImage,
                title: title
            });
        }

                if ($('#open-map').length>0) {
            initOpenStreetMap();
        }

        function initOpenStreetMap(){
            var mapHeight = getWindowHeight() * 0.4;
            if (mapHeight < 400) {
                mapHeight = 400;
            }

            $('#open-map').css( 'height', mapHeight);
            map = L.map('open-map').setView([omap.center_lat, omap.center_lng], omap.zoom);

            // add an OpenStreetMap tile layer
            var tile = L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
            });
            tile.addTo(map);
            addOpenMarkers();
        }

        function addOpenMarkers() {
            var markers = omap.markers;
            var imgUrl = $('#open-map').attr('data-marker');
            var mapIcons = [];
            mapIcons.st = L.icon({
                iconUrl: imgUrl,
                iconSize: [30, 50]
            });
/*            mapIcons['w'] = L.icon({
                iconUrl: imgUrl + 'status-s-w.png',
                iconSize: [20, 20]
            });
            mapIcons['wr'] = L.icon({
                iconUrl: imgUrl + 'status-s-wr.png',
                iconSize: [20, 20]
            });*/

            for (var i=0; i < markers.length; i++) {
                var lat = markers[i].lat,
                    lng = markers[i].lng,
                    markerTitle = markers[i].default_label;
                L.marker([ lat, lng ], {title: markerTitle, icon: mapIcons.st }).addTo(map);
            }
        }

        //click trigger
        function bindClick() {
            $('.clickTrigger').on('click', function(e) {
                e.preventDefault();
                var targetLine = $(this).data('target');
                var $target = $( targetLine);
                $target.trigger( "click" );

            });
        }

        //Scroll to el if page has Hash
        if(window.location.hash) {
            var hash = window.location.hash;
            if ($(hash).length>0) {
                scrollToEl(hash, 220);
            }
        }

        //function scroll to element
        function scrollToEl(target, offset) {
            var $target = $(target);
            $("html, body").animate({ scrollTop: $target.offset().top - (offset + 70)}, 1000);
        }

        function updateWData() {
            wdata.ww = getWindowWidth();
            wdata.wh = getWindowHeight();
            wdata.scroll =  $(window).scrollTop();

            if (wdata.debug == true) {
                console.info('updateWData');
                console.log(wdata);
            }
        }

        setTimeout(function(){
            $('div,ul,li,a,label,iframe').removeAttr('role');
            $('.swiper-slide').removeAttr('aria-label');
        }, 3000);

        function lazyBg(){
            var TopPos = $(window).scrollTop(),
                BottomPos = TopPos + $(window).height();
            var use = 'src';
            if (wdata.ww > 1200) {
                use = 'large';
            }
            $.each($('.lazy-bg.blur'), function() {
                var TopElement = $(this).offset().top,
                    BotElement = TopElement + $(this).height(),
                    diff = $(this).height() * 0.6;
                TopElement = diff + TopElement;
                BotElement = BotElement - diff;
                if ((BotElement <= BottomPos) && (TopElement >= TopPos)) {
                    var imgSrc = $(this).attr('data-'+use),
                        hash = $(this).attr('data-hash');
                    loadImage(imgSrc, hash).then(function(img){
                        $('.lazy-bg[data-hash='+hash+']').attr('style', 'background-image: url('+imgSrc+');').removeClass('blur').addClass(use);
                    });
                }
            });
        }

        function layoutBlockVis(){
            $.each($('.fc-row:not(:first)'), function() {
                var id = $(this).attr('id');
                if (isInViewPort('#'+id)) {
                    $('#'+id).removeClass('non-visible').addClass('is-visible');
                }
                else {
                    $('#'+id).addClass('non-visible').removeClass('is-visible');
                }
            });

            if ($('.fc-row.last-row').maxLength> 0) {
                if (isInViewPort('.fc-row.last-row')) {
                    $('footer.footer').removeClass('non-visible').addClass('is-visible');
                }
                else {
                    $('footer.footer').addClass('non-visible').removeClass('is-visible');
                }
            }
        }

        //check if element is visible #element, .element
        function isElementVisible(elementToBeChecked) {
            var TopView = $(window).scrollTop();
            var BotView = TopView + $(window).height();
            var TopElement = $(elementToBeChecked).offset().top;
            var BotElement = TopElement + $(elementToBeChecked).height();
            return ((BotElement <= BotView) && (TopElement >= TopView));
        }

        function blockPositionsData(elementToBeChecked) {
            var TopView = $(window).scrollTop(),
                BotView = TopView + $(window).height(),
                TopElement = $(elementToBeChecked).offset().top,
                BotElement = TopElement + $(elementToBeChecked).height(),
                elementHeight = $(elementToBeChecked).height();
            var data = [];
            data.top = TopView;
            data.bottom = BotView;
            data.height = elementHeight;
            data.posTop = TopElement;
            data.posBottom = BotElement;
            return data;
        }

        function isInViewPort(elementToBeChecked) {
            var TopView = $(window).scrollTop();
            var BotView = TopView + $(window).height();
            var TopElement = $(elementToBeChecked).offset().top;
            var BotElement = TopElement + $(elementToBeChecked).height();
            var elementHeight = $(elementToBeChecked).height();
            var status = false;
            if ((TopView - elementHeight) < TopElement && BotView > (BotElement - elementHeight)) {
                status = true;
            }
            return status;
        }

        function svgSupport() {
            if (typeof SVGRect != "undefined") {
                $('body').addClass('svg');
                var status = true;
            }
            else {
                $('body').addClass('no-svg');
                var status = false;
                $.each($('img[data-png]'), function(){
                    var png = $(this).attr('data-png'),
                        width = $(this).width(),
                        height = $(this).height();
                    if (svg != undefined && png != '') {
                        $(this).attr('src', png);
                    }
                });
            }
            if (window.devicePixelRatio > 1.3) {
                $('body').addClass('retina');
            }
            return status;
        }

        function cf7Hooks(){
            if ($('form.wpcf7-form').length> 0) {

                $('form.wpcf7-form button[type=submit]').on('click', function(e){
                    var status = $(this).closest('form.wpcf7-form').attr('data-status');
                    var formId = $(this).closest('form.wpcf7-form').parent().attr('id');
                    qdata.cf7check = formId;
                    qdata.cf7status = status;
                    qdata.cf7time = 0;
                    setTimeout(checkCf7, 500);
                });

                function checkCf7(){
                    var formID = qdata.cf7check;
                    status = qdata.cf7status,
                        currentStatus = $('#'+formID).find('form.wpcf7-form').attr('data-status'),
                        cf7time = qdata.cf7time;

                    cf7time = cf7time + 500;
                    qdata.cf7time = cf7time;
                    if (currentStatus == status) {
                        if (qdata.cf7time < 10000) {
                            setTimeout(checkCf7, 500);
                        }
                        else {
                            $('#'+formID+' form button[type=submit]').prop('disabled', true);
                            //  $('#'+formID+' form').append('<div class="q-doing-ajax"><span class="icon-rotate"></span></div>');
                        }
                    }
                    else {
                        if (currentStatus == 'submitting') {
                            qdata.cf7status = currentStatus;
                            $('#'+formID+' form button[type=submit]').prop('disabled', true);
                            //     $('#'+formID+' form').append('<div class="q-doing-ajax"><span class="icon-rotate"></span></div>');
                            setTimeout(checkCf7, 500);
                        }
                        else {
                            $('#'+formId+' form button[type=submit]').prop('disabled', false);
                            //   $('#'+formId+' form .q-doing-ajax').remove();
                        }
                    }
                }
            }
        }
        setTimeout(cf7Hooks, 3000);

    //Document Ready ENDS
    });
})(jQuery);

/* Array to JSON */
function encodeJSON(fields) {
    var jsonLine = JSON.stringify(fields);
    return jsonLine;
}

/* JSON to array */
function decodeJSON(string) {
    var array = jQuery.parseJSON(string);
    return array;
}

function searchParams(url) {
    if (url == undefined) {
        url = window.location.href;
    }
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
}

//window height
function getWindowHeight() {
    return jQuery( window ).height();
}

//window width
function getWindowWidth() {
    return jQuery( window ).width();
}

//validate Phone
function validatePhone(phone) {
    var re = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
    return re.test(phone);
}

//validate Email
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function loadImage(imgSrc, hash) {
    return new Promise( function(resolve, reject) {
        var img = new Image();
        img.onload = function() {
            resolve(img);
        };
        img.onerror = function() {
            reject(img);
        };
        img.src = imgSrc;
    })
}
